import request from '@/utils/request'
//获取table表格数据
export function getPlanComm (data) {
  return request({
    url: `/planComm/getList`,
    method: 'post',
    data,
  })
}
//获取所有老师
export function getTeachers () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}
//获取所有学生
export function getStudents () {
  return request({
    url: `student/getStudentList`,
    method: 'get',
  })
}
//添加保存
export function addItem (data) {
  return request({
    url: `/planComm/add`,
    method: 'post',
    data
  })
}
//修改销售完成情况状态
export function changeSta (data) {
  return request({
    url: `/planComm/isOver?id=${data.id}&isOver=${data.isOver}`,
    method: 'get',
  })
}
//编辑回显
export function editItem (id) {
  return request({
    url: `/planComm/detail?id=${id}`,
    method: 'get',
  })
}
//编辑保存
export function editSave (data) {
  return request({
    url: `/planComm/update`,
    method: 'post',
    data
  })
}
//详情
export function getdeta (id) {
  return request({
    url: `/planComm/detail?id=${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/communicateApi.js